import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "profile-page" }

import { reactive, ref, computed } from "vue";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { UserServiceApi } from "@/services/dataService";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserProfile',
  setup(__props) {

const store = useStore();
const user = computed(() => store.getters.getUser || { username: "" });
const loading = ref(false);

const profileForm = reactive({ display_name: user.value?.display_name || "" });
const pwdForm = reactive({ old_password: "", new_password: "", confirm: "" });

const saveProfile = async () => {
  loading.value = true;
  try {
    const resp = await UserServiceApi.updateMyProfile(profileForm.display_name);
    const ok =
      (resp as { data?: { code?: number; message?: string } }).data?.code === 0;
    if (ok) {
      ElMessage.success("个人资料已更新");
      await store.dispatch("fetchUserInfo");
    } else {
      const msg =
        (resp as { data?: { message?: string } }).data?.message || "更新失败";
      ElMessage.error(msg);
    }
  } finally {
    loading.value = false;
  }
};

const changePassword = async () => {
  if (!pwdForm.old_password || !pwdForm.new_password) {
    ElMessage.warning("请输入完整的密码信息");
    return;
  }
  if (pwdForm.new_password !== pwdForm.confirm) {
    ElMessage.warning("两次输入的新密码不一致");
    return;
  }
  loading.value = true;
  try {
    const resp = await UserServiceApi.updateMyPassword(
      pwdForm.old_password,
      pwdForm.new_password
    );
    const ok =
      (resp as { data?: { code?: number; message?: string } }).data?.code === 0;
    if (ok) {
      ElMessage.success("密码已更新");
      Object.assign(pwdForm, {
        old_password: "",
        new_password: "",
        confirm: "",
      });
    } else {
      const msg =
        (resp as { data?: { message?: string } }).data?.message || "修改失败";
      ElMessage.error(msg);
    }
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "box-card",
      header: "个人资料"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: profileForm,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "用户名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: user.value.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.username) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "显示名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: profileForm.display_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profileForm.display_name) = $event)),
                  placeholder: "请输入显示名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: saveProfile
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("保存", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      class: "box-card",
      header: "修改密码",
      style: {"margin-top":"16px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: pwdForm,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "原密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: pwdForm.old_password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((pwdForm.old_password) = $event)),
                  type: "password",
                  "show-password": "",
                  placeholder: "请输入原密码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "新密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: pwdForm.new_password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((pwdForm.new_password) = $event)),
                  type: "password",
                  "show-password": "",
                  placeholder: "至少8位且包含字母与数字"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "确认新密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: pwdForm.confirm,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((pwdForm.confirm) = $event)),
                  type: "password",
                  "show-password": "",
                  placeholder: "再次输入新密码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: changePassword
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("修改密码", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})